import config from '../config/environment';

// API Utility Functions
export const getBackendUrl = () => config.BACKEND_URL;
export const getApiUrl = () => config.API_BASE_URL;

// Pre-configured fetch function with authentication
export const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  const baseUrl = getApiUrl();
  
  // Ensure endpoint starts without slash if baseUrl ends with /api
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  const url = `${baseUrl}/${cleanEndpoint}`;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    }
  };
  
  const finalOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers
    }
  };
  
  console.log(`🌐 API Request: ${options.method || 'GET'} ${url}`);
  
  try {
    const response = await fetch(url, finalOptions);
    
    if (!response.ok) {
      if (response.status === 401) {
        console.warn('🔒 Authentication failed - removing token');
        localStorage.removeItem('token');
        throw new Error('Session expired. Please log in again.');
      }
      
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
    }
    
    return response;
  } catch (error) {
    console.error(`❌ API Error (${url}):`, error);
    throw error;
  }
};

// Common API methods
export const api = {
  get: (endpoint, options = {}) => apiRequest(endpoint, { ...options, method: 'GET' }),
  post: (endpoint, data, options = {}) => apiRequest(endpoint, { 
    ...options, 
    method: 'POST', 
    body: JSON.stringify(data) 
  }),
  put: (endpoint, data, options = {}) => apiRequest(endpoint, { 
    ...options, 
    method: 'PUT', 
    body: JSON.stringify(data) 
  }),
  delete: (endpoint, options = {}) => apiRequest(endpoint, { ...options, method: 'DELETE' }),
};

// Legacy support - for backward compatibility with existing code
export const getLegacyApiUrl = () => {
  // This matches the old pattern but now uses our centralized config with environment variables
  // Format: process.env.REACT_APP_API_URL || 'http://localhost:${BACKEND_PORT}/api'
  return getApiUrl();
};

export default api;
